import script from "./NonCurrentAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./NonCurrentAssets.vue?vue&type=script&setup=true&lang=js"

import "./NonCurrentAssets.vue?vue&type=style&index=0&id=eba2061e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eba2061e"]])

export default __exports__